module.exports = __webpack_public_path__ + "img/产品中心-产品背景图1.0f427a04.png";